import React from "react";
import Button from "../Button";

/**
 * ButtonGroup component for containing multiple buttons
 */
const ButtonGroup = ({
  handleClose,
  handleSubmit,
  isSubmitting,
  text = "white",
  background = "#62BA09",
  size = "medium",
  textTransform = "uppercase",
  wrapperStyle = {},
}) => {
  // Base styles for the group container
  const groupContainerStyle = {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginRight: "10px",
    paddingBottom: "10px",
    ...wrapperStyle, // Apply any custom styles passed in through wrapperStyle
  };

  // Style for the spacer element
  const spacerStyle = {
    margin: "0 5px",
  };

  return (
    <div style={groupContainerStyle}>
      <Button
        label="Cancel"
        onClick={handleClose}
        text="#407A28"
        background={background}
        textTransform={textTransform}
        size={size}
        variant="outlined"
        data-testid="cancel"
      />
      <span style={spacerStyle}></span>
      <Button
        onClick={handleSubmit}
        disabled={isSubmitting}
        label="Save"
        text={text}
        background={background}
        textTransform={textTransform}
        size={size}
        data-testid="submit"
      />
    </div>
  );
};

export default ButtonGroup;
